// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  text-decoration: none;
}

.ditem {
  font-style: italic !important;
}

.option:before {
  font-style: italic;
}

.cardd {
  border-radius: 12px;
  padding-bottom: 10px;
  text-align: left;
}

.cr {
  padding-left: 20px;
}

.scname {
  font-style: italic;
  font-weight: bold;
}

.heading {
  padding: 0.7rem 0.5rem;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: #2a9679 !important;
  color: white;
  font-weight: 500;
  font-size: 16px;
  font-family: "Roboto", "Helvetica Neue", Arial, Tahoma;
  text-align: center;
}

.op {
  font-style: italic;
}

select option {
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/pages/Hosts/Animal.scss"],"names":[],"mappings":"AAIA;EACI,qBAAA;AAHJ;;AAMA;EACI,6BAAA;AAHJ;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,mBAAA;EACA,oBAAA;EACA,gBAAA;AAHJ;;AAOA;EACI,kBAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,iBAAA;AAJJ;;AAOA;EACI,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,sDAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,kBAAA;AAJJ;;AAOA;EACI,kBAAA;AAJJ","sourcesContent":["@import '../../scss/colors';\n@import '../../scss/globals';\n\n\na {\n    text-decoration: none\n}\n\n.ditem {\n    font-style: italic !important;\n}\n\n.option:before {\n    font-style: italic;\n}\n\n.cardd {\n    border-radius: 12px;\n    padding-bottom: 10px;\n    text-align: left;\n\n}\n\n.cr {\n    padding-left: 20px;\n}\n\n.scname {\n    font-style: italic;\n    font-weight: bold;\n}\n\n.heading {\n    padding: 0.7rem 0.5rem;\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n    background-color: $palette-1 !important;\n    color: white;\n    font-weight: 500;\n    font-size: 16px;\n    font-family: \"Roboto\", \"Helvetica Neue\", Arial, Tahoma;\n    text-align: center;\n}\n\n.op {\n    font-style: italic;\n}\n\nselect option {\n    font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
